import { render, staticRenderFns } from "./Switchs.vue?vue&type=template&id=8b1b2d70&scoped=true&"
import script from "./Switchs.vue?vue&type=script&lang=js&"
export * from "./Switchs.vue?vue&type=script&lang=js&"
import style0 from "./Switchs.vue?vue&type=style&index=0&id=8b1b2d70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b2d70",
  null
  
)

export default component.exports